import React, { useEffect, useState,Suspense, lazy } from 'react'
import Image from "../components/elements/Image"
import siteLogo from "../assets/images/logo.png"
import Button from "../components/form/Button"
import { useParams } from 'react-router-dom'
import { apiRequest } from '../util/apiUtils'
import { useBistroNavigation } from '../hooks/useBistroNavigation'
//const QRScanner = lazy(() => import('../components/QRScanner'));

const Home = () => {  
  const params = useParams();
  const tableNumber = params?.table;
  const [remainingAmount, setRemainingAmount] = useState(0);
  const [showScanner, setShowScanner] = useState(false);
  const [loading, setLoading] = useState(true);
  const { getPath, config } = useBistroNavigation();

  useEffect(() => {
    const fetchOrderDetails = async () => {
      setLoading(true);
      try {
        const result = await apiRequest("post", `order/order-detail`, {
          body: { tableNumber },
        });
        if (result.status === 200) {
          const orderData = result?.data?.data || {};
          const billAmount = orderData?.billAmount || 0;
          const paidAmount = Array.isArray(orderData?.miniStatement)
            ? orderData.miniStatement.reduce((sum, item) => sum + (Number(item.amount) || 0), 0)
            : 0;
          const remaining = billAmount - paidAmount;     
          setRemainingAmount(remaining);         
        }
      } catch (error) {
        console.error("Error fetching order details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrderDetails();
  }, [tableNumber]);

  return (
    <div className="w-full h-screen flex items-center justify-center">
      <div className="max-w-96 w-full h-full flex flex-col justify-center mx-auto px-5 border border-blue-200">
        <div className="w-52 aspect-square overflow-hidden mx-auto">
          <Image src={config?.logo} classes={'object-cover'} />
        </div>
        <div className={`mt-20 flex items-center gap-3 ${remainingAmount > 0 ? 'justify-between' : 'justify-center'}`}>
          <Button
            buttonLabel={'View Menu'}
            buttonLabelClasses={"font-Roboto font-semibold text-lg capitalize"}
            buttonClasses={"border border-blue-500 hover:bg-blue-100 hover:text-blue-500 h-12 w-[50%]"}
            buttonHasLink={true}
            buttonLink={getPath((tableNumber && tableNumber !== undefined)?`/menu/table/${tableNumber}`:`/menu`)}
          />
          {/* <Button
            buttonLabel="Scan QR Code"
            buttonFunction={() => setShowScanner(true)}
          />

          {showScanner && (
            <Suspense fallback={<div>Loading scanner...</div>}>
              <QRScanner onClose={() => setShowScanner(false)} />
            </Suspense>
          )} */}
          {/* <Button
            buttonLabel={'Bill Pay'}
            buttonLabelClasses={"font-Roboto font-semibold text-lg capitalize"}
            buttonClasses={"bg-buttonPrimary rounded-[10px] w-full h-12"}
            buttonHasLink={true}
            buttonLink={"/bistro/bill/table/1"}
          /> */}

          {typeof remainingAmount === "number" && remainingAmount > 0 && (
            <Button
              buttonLabel={`Pay Now $${remainingAmount.toFixed(2)}`}
              buttonLabelClasses="font-Roboto font-semibold text-lg capitalize"
              buttonClasses="border border-blue-500 hover:bg-blue-100 hover:text-blue-500 h-12 w-[50%]"
              buttonHasLink
              buttonLink={getPath(`/paybill/table/${tableNumber}`)} // ✅ dynamic table link
            />
          )}          
        </div>
      </div>
    </div>
  )
}

export default Home